export default __webpack_public_path__ + "static/media/SaraSmithResume.3dd2ef1d.pdf";